import { z } from 'zod';

export { featuresResponseSchema as loanFeaturesStepsResponseSchema } from '@/api/credit/schemas';

export const signOfferResponseSchema = z.object({
  orderId: z.string(),
  autoStartToken: z.string(),
});

export const acceptOfferResponseSchema = z.object({
  authToken: z.string(),
  agreementId: z.string(),
});

const withdrawalSuccessLoanPartnerResponseSchema = z.object({
  status: z.literal('SUCCESS'),
});

export const withdrawalSuccessLoanResponseSchema = z.object({
  status: z.literal('SUCCESS'),
  transactionId: z.string(),
});

export const withdrawalStatusResponseSchema = z.union([
  z.object({
    status: z.enum(['PENDING', 'FAILED']),
  }),
  withdrawalSuccessLoanResponseSchema,
  withdrawalSuccessLoanPartnerResponseSchema,
]);
